module.exports = __webpack_public_path__ + "img/diagram-360.df3b1c6a.jpg";